import React, { useEffect, useMemo, useState } from "react";
import "./App.css";
import Logo from "./logo.png"; // podmień na własne (może być .png)

//
// === KONFIG ===
//
const DISCORD_URL = "https://discord.gg/Xh7VKe3MpU"; // <- Twój link (np. https://discord.gg/xxx)
const LAUNCH_ISO = "2025-11-28T18:00:00+01:00"; // <- Twoja data startu (Europe/Warsaw)
const BG_URL = "https://i.imgur.com/cEjOuoD.png"; // tło (cover, zawsze wypełnia)

// Loader – sterowanie czasem
const LOADER_MIN_MS = 2500; // minimalny czas loadera
const LOADER_MAX_MS = 7000; // twardy max (fallback)

// ===== Utils =====
function useCountdown(targetISO) {
    const target = useMemo(() => new Date(targetISO).getTime(), [targetISO]);
    const [now, setNow] = useState(() => Date.now());
    useEffect(() => {
        const iv = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(iv);
    }, []);
    const diff = Math.max(0, target - now);
    const total = Math.floor(diff / 1000);
    const days = Math.floor(total / 86400);
    const hours = Math.floor((total % 86400) / 3600);
    const mins = Math.floor((total % 3600) / 60);
    const secs = total % 60;
    return { days, hours, mins, secs };
}

export default function App() {
    const { days, hours, mins, secs } = useCountdown(LAUNCH_ISO);

    // Loader: czekaj na tło + fonty, wymuś min. czas, ale nie przekraczaj max
    const [ready, setReady] = useState(false);
    useEffect(() => {
        document.documentElement.style.setProperty("--bg-url", `url("${BG_URL}")`);
        const start = performance.now();
        let finished = false;

        const preloadImage = new Promise((res) => {
            const img = new Image();
            img.onload = res;
            img.onerror = res;
            img.src = BG_URL;
        });

        const fontsReady = document.fonts ? document.fonts.ready : Promise.resolve();

        const finish = () => {
            if (finished) return;
            finished = true;
            const elapsed = performance.now() - start;
            const wait = Math.max(0, LOADER_MIN_MS - elapsed);
            setTimeout(() => setReady(true), wait);
        };

        Promise.allSettled([preloadImage, fontsReady]).then(finish);
        const to = setTimeout(finish, LOADER_MAX_MS);
        return () => clearTimeout(to);
    }, []);

    return (
        <div className={`root ${ready ? "ready" : ""}`}>
            {/* TŁO COVER – zawsze wypełnia viewport */}
            <div className="bg-cover" aria-hidden />
            <div className="fx-shade" aria-hidden />

            {/* LOADER wejścia – pulsujące logo + DUŻE „ŁADOWANIE” */}
            <div className={`loader ${ready ? "hide" : ""}`} aria-hidden={ready ? "true" : "false"}>
                <div className="loader-inner">
                    <img src={Logo} alt="Logo" className="logo-pulse big" />
                    <div className="loader-title">ŁADOWANIE...</div>
                </div>
            </div>

            {/* LOGO na górze (puls) */}
            <header className="logo-bar">
                <img src={Logo} alt="Logo" className="logo-pulse" />
            </header>

            {/* CONTENT — WYŚRODKOWANY */}
            <div className="content">
                <main className="main main-center">
                    <section className="panel clean" aria-label="Odliczanie do startu">
                        <h1 className="title">Startujemy wkrótce</h1>
                        <p className="subtitle">
                            Odliczamy do otwarcia. Wpadnij na Discord i bądź na bieżąco.
                        </p>

                        <div className="countdown calm" role="timer" aria-live="polite">
                            {[
                                { v: days, l: "dni" },
                                { v: hours, l: "godz." },
                                { v: mins, l: "min" },
                                { v: secs, l: "sek" },
                            ].map(({ v, l }) => (
                                <div className="cell calm" key={l}>
                                    <div className="num">{String(v).padStart(2, "0")}</div>
                                    <div className="lab">{l}</div>
                                </div>
                            ))}
                        </div>

                        <div className="cta">
                            <a
                                className="btn btn-discord"
                                href={DISCORD_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fa-brands fa-discord discord-icon" aria-hidden="true"></i>
                                <span>Dołącz na Discord</span>
                            </a>

                        </div>
                    </section>
                </main>
            </div>
        </div>
    );
}
